<ng-container *ngIf="loading$ | async">
    <app-is-loading></app-is-loading>
</ng-container>

<body class="announcements annContainer" style="border: unset !important;">
    <div [innerHTML]="termsObject.title"></div>
    <div style="text-align: left;" [innerHTML]="termsObject.paragraph"></div>
    <div [innerHTML]="termsObject.footer"></div>
    <div style="float: left; padding: 16px;"><button type="button" class="btn btn-outline-dark" mat-raised-button color="primary" (click)=agree()>I Agree</button></div>
</body>